import {FC, useEffect, useState} from 'react'
import {Controller, useFormContext} from 'react-hook-form'
import Select from 'react-select'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {CampModel, MasterModel, SiteModel} from '../../models'
import {getModuleByIdService} from '../../services'
import {getCampsService} from '../../services/getCamps.service'
import {getMasterModuleService} from '../../services/getModuleTypes.service'
import {getSitesService} from '../../services/getSites.service'

const FormNewModule: FC = () => {
  const {currentTabItem} = useHoteleria()
  const [sites, setSites] = useState<SiteModel[] | any>([])
  const [camps, setCamps] = useState<CampModel[] | any>([])
  const [moduleType, setModuleType] = useState<MasterModel[] | any>([])
  const [level, setLevel] = useState<MasterModel[] | any>([])
  const [preasignationType, setPreasignationType] = useState<MasterModel[] | any>([])
  const [genre, setGenre] = useState<MasterModel[] | any>([])
  const [bathroomType, setBathroomType] = useState<MasterModel[] | any>([])
  const [statusType, setStatusType] = useState<MasterModel[] | any>([])

  const {
    register,
    formState: {errors},
    control,
    setValue,
    watch,
  } = useFormContext()

  const getSites = async () => {
    let obj: SiteModel = {
      id: '',
      nombre: '',
      campoadicionaltxt1: '',
      campoadicionaltxt2: '',
      campoadicionaltxt3: '',
      campoadicionaltxt4: '',
      campoadicionaltxt5: '',
      campoadicionalnum1: 0,
      campoadicionalnum2: 0,
      campoadicionalnum3: 0,
      campoadicionalFec1: '',
      campoadicionalFec2: '',
      fechaRegistro: '',
      usuarioRegistro: '',
      iPPlacaRegistro: '',
      fechaModificacion: '',
      usuarioModificacion: '',
      iPPlacaModificacion: '',
      fechaEliminacion: '',
      usuarioEliminacion: '',
      iPPlacaEliminacion: '',
    }
    const response = await getSitesService(obj, 1)
    const data = response.data.data
    const mappedSites = data?.map((site) => ({value: site.id, label: site.nombre}))
    setSites(mappedSites)
  }
  const getCamps = async (siteId: string) => {
    let obj: CampModel = {
      id: '',
      nombre: '',
      siteId: siteId,
      clienteId: '',
      companiaId: '',
      site: '',
      nombreCliente: '',
      nombreCompania: '',
    }
    const response = await getCampsService(obj, 1)
    const data = response.data.data
    const mappedCamps = data?.map((camp) => ({value: camp.id, label: camp.nombre}))
    setCamps(mappedCamps)
  }
  const getModuleTypes = async () => {
    const response = await getMasterModuleService({
      pageNumber: 1,
      size: 100,
      tableName: 'TipoModulo',
    })
    const data = response.data.data
    const mappedModuleTypes = data?.map((moduleType) => ({
      value: moduleType.id,
      label: moduleType.nombreCorto,
    }))
    setModuleType(mappedModuleTypes)
  }
  const getLevels = async () => {
    const response = await getMasterModuleService({
      pageNumber: 1,
      size: 100,
      tableName: 'Nivel',
    })
    const data = response.data.data
    const mappedMaster = data?.map((master) => ({
      value: master.id,
      label: master.nombreCorto,
    }))
    setLevel(mappedMaster)
  }
  const getStatusTypes = async () => {
    const response = await getMasterModuleService({
      pageNumber: 1,
      size: 100,
      tableName: 'EstadoModulo',
    })
    const data = response.data.data
    const mappedMaster = data?.map((master) => ({
      value: master.id,
      label: master.nombreCorto,
    }))
    setStatusType(mappedMaster)
  }
  const getPreasignationTypes = async () => {
    const response = await getMasterModuleService({
      pageNumber: 1,
      size: 100,
      tableName: 'TipoPreasignacion',
    })
    const data = response.data.data
    const mappedMaster = data?.map((master) => ({
      value: master.id,
      label: master.nombreCorto,
    }))
    setPreasignationType(mappedMaster)
  }
  const getGenres = async () => {
    const response = await getMasterModuleService({
      pageNumber: 1,
      size: 100,
      tableName: 'Sexo',
    })
    const data = response.data.data
    const mappedMaster = data?.map((master) => ({
      value: master.id,
      label: master.nombreCorto,
    }))
    setGenre(mappedMaster)
  }
  const getBathroomsType = async () => {
    const response = await getMasterModuleService({
      pageNumber: 1,
      size: 100,
      tableName: 'TipoBanio',
    })
    const data = response.data.data
    const mappedMaster = data?.map((master) => ({
      value: master.id,
      label: master.nombreCorto,
    }))
    setBathroomType(mappedMaster)
  }

  useEffect(() => {
    getSites()
    getModuleTypes()
    getLevels()
    getPreasignationTypes()
    getGenres()
    getBathroomsType()
    getStatusTypes()
    setValue('EstadoModuloId', 'qWH44eZGS2A=') // DISPONIBLE
  }, [])

  useEffect(() => {
    const siteId = watch('SiteId')
    if (siteId) {
      setValue('CampamentoId', '')
      getCamps(siteId)
    }
  }, [watch('SiteId')])

  const getModuleById = async () => {
    // Object.keys(initValues).forEach((fieldName: string) => {
    // 	if (data.hasOwnProperty(fieldName)) {
    // 		if(data[fieldName]){
    // 			setValue(fieldName, data[fieldName]);
    // 		}else{
    // 			setValue(fieldName, '');
    // 		}
    // 	}
    // });
    const {idToEdit} = currentTabItem
    if (idToEdit) {
      const {
        data: {data},
      } = await getModuleByIdService(idToEdit)
      const {
        CampamentoId,
        SiteId,
        TipoModuloId,
        Codigo,
        EstadoModuloId,
        TipoPreAsignacionId,
        SexoId,
        TipoBanioId,
        NivelId,
        NroHabitaciones,
        PrioridadAsignacionId,
      } = data
      setValue('Id', idToEdit)
      setValue('CampamentoId', CampamentoId)
      setValue('SiteId', SiteId)
      setValue('TipoModuloId', TipoModuloId)
      setValue('Codigo', Codigo)
      setValue('EstadoModuloId', EstadoModuloId)
      setValue('TipoPreAsignacionId', TipoPreAsignacionId)
      setValue('SexoId', SexoId)
      setValue('TipoBanioId', TipoBanioId)
      setValue('NivelId', NivelId)
      setValue('NroHabitaciones', NroHabitaciones)
      setValue('PrioridadAsignacion', PrioridadAsignacionId)
    }
  }
  useEffect(() => {
    const {idToEdit} = currentTabItem
    if (idToEdit) {
      getModuleById()
    }
  }, [])
  return (
    <>
      <KTCard shadow className='m-5'>
        <div className='p-6'>
          <div className='d-flex row'>
            <div className='col-xs-12 col-sm-6 col-lg-3'>
              <div className='mb-2 col-10'>
                <label className='required form-label'>Site</label>
                <div className='input-group input-group-sm'>
                  <Controller
                    control={control}
                    name='SiteId'
                    render={({field}) => (
                      <Select
                        {...field}
                        key={field.value}
                        className='w-100'
                        options={sites}
                        placeholder='Selecciona un site'
                        value={sites?.find((c: {value: string}) => c.value === field.value)}
                        onChange={(val) => field.onChange(val ? val.value : '')}
                      />
                    )}
                  />
                  <p
                    style={{
                      marginBottom: '0',
                      fontSize: '10px',
                      fontWeight: '600',
                      color: 'red',
                      marginLeft: '5px',
                    }}
                  >
                    {errors.SiteId && typeof errors.SiteId === 'string' && errors.SiteId}
                  </p>
                </div>
              </div>
              <div className='mb-2 col-10'>
                <label className='required form-label'>Campamento</label>
                <div className='input-group input-group-sm'>
                  <Controller
                    control={control}
                    name='CampamentoId'
                    render={({field}) => (
                      <Select
                        {...field}
                        key={field.value}
                        className='w-100'
                        options={camps}
                        placeholder='Selecciona un campamento'
                        value={camps?.find((c: {value: string}) => c.value === field.value)}
                        onChange={(val) => field.onChange(val ? val.value : '')}
                      />
                    )}
                  />
                  <p
                    style={{
                      marginBottom: '0',
                      fontSize: '10px',
                      fontWeight: '600',
                      color: 'red',
                      marginLeft: '5px',
                    }}
                  >
                    {errors.CampamentoId &&
                      typeof errors.CampamentoId === 'string' &&
                      errors.CampamentoId}
                  </p>
                </div>
              </div>
              <div className='mb-2 col-10'>
                <label className='required form-label'>Tipo de Módulo</label>
                <div className='input-group input-group-sm'>
                  <Controller
                    control={control}
                    name='TipoModuloId'
                    render={({field}) => (
                      <Select
                        {...field}
                        key={field.value}
                        className='w-100'
                        options={moduleType}
                        placeholder='Selecciona un tipo de modulo'
                        value={moduleType?.find((c: {value: string}) => c.value === field.value)}
                        onChange={(val) => field.onChange(val ? val.value : '')}
                      />
                    )}
                  />
                  <p
                    style={{
                      marginBottom: '0',
                      fontSize: '10px',
                      fontWeight: '600',
                      color: 'red',
                      marginLeft: '5px',
                    }}
                  >
                    {errors.TipoModuloId &&
                      typeof errors.TipoModuloId === 'string' &&
                      errors.TipoModuloId}
                  </p>
                </div>
              </div>
            </div>
            <div className='col-xs-12 col-sm-6 col-lg-3'>
              <div className='mb-2 col-10'>
                <label className='required form-label'>Código de Módulo</label>
                <div className=''>
                  <div className='sdx_form_input p-0'>
                    <input
                      type='text'
                      className='form-control sdx-centra-input-form'
                      {...register('Codigo')} // Aplicar las reglas de validación al registro
                    />
                  </div>
                  <p
                    style={{
                      marginBottom: '0',
                      fontSize: '10px',
                      fontWeight: '600',
                      color: 'red',
                      marginLeft: '5px',
                    }}
                  >
                    {errors.Codigo && typeof errors.Codigo === 'string' && errors.Codigo}
                  </p>
                </div>
              </div>
              <div className='mb-2 col-10'>
                <label className='required form-label'>Estado</label>
                <div className='input-group input-group-sm'>
                  <Controller
                    control={control}
                    name='EstadoModuloId'
                    render={({field}) => (
                      <Select
                        {...field}
                        key={field.value}
                        className='w-100'
                        options={statusType}
                        placeholder='Selecciona un estado'
                        value={statusType?.find((c: {value: string}) => c.value === field.value)}
                        onChange={(val) => field.onChange(val ? val.value : '')}
                      />
                    )}
                  />
                </div>
                <p
                  style={{
                    marginBottom: '0',
                    fontSize: '10px',
                    fontWeight: '600',
                    color: 'red',
                    marginLeft: '5px',
                  }}
                >
                  {errors.EstadoModuloId &&
                    typeof errors.EstadoModuloId === 'string' &&
                    errors.EstadoModuloId}
                </p>
              </div>
              <div className='mb-2 col-10'>
                <label className='required form-label'>Preasignación</label>
                <div className='input-group input-group-sm'>
                  <Controller
                    control={control}
                    name='TipoPreAsignacionId'
                    render={({field}) => (
                      <Select
                        {...field}
                        key={field.value}
                        className='w-100'
                        options={preasignationType}
                        placeholder='Selecciona un tipo de preasignacion'
                        value={preasignationType?.find(
                          (c: {value: string}) => c.value === field.value,
                        )}
                        onChange={(val) => field.onChange(val ? val.value : '')}
                      />
                    )}
                  />
                  <p
                    style={{
                      marginBottom: '0',
                      fontSize: '10px',
                      fontWeight: '600',
                      color: 'red',
                      marginLeft: '5px',
                    }}
                  >
                    {errors.TipoPreAsignacionId &&
                      typeof errors.TipoPreAsignacionId === 'string' &&
                      errors.TipoPreAsignacionId}
                  </p>
                </div>
              </div>
            </div>
            <div className='col-xs-12 col-sm-6 col-lg-3'>
              <div className='mb-2 col-10'>
                <label className='required form-label'>Sexo</label>
                <div className='input-group input-group-sm'>
                  <Controller
                    control={control}
                    name='SexoId'
                    render={({field}) => (
                      <Select
                        {...field}
                        key={field.value}
                        className='w-100'
                        options={genre}
                        placeholder='Selecciona un Sexo'
                        value={genre?.find((c: {value: string}) => c.value === field.value)}
                        onChange={(val) => field.onChange(val ? val.value : '')}
                      />
                    )}
                  />
                  <p
                    style={{
                      marginBottom: '0',
                      fontSize: '10px',
                      fontWeight: '600',
                      color: 'red',
                      marginLeft: '5px',
                    }}
                  >
                    {errors.SexoId && typeof errors.SexoId === 'string' && errors.SexoId}
                  </p>
                </div>
              </div>
              <div className='mb-2 col-10'>
                <label className='required form-label'>Tipo de Baño</label>
                <div className='input-group input-group-sm'>
                  <Controller
                    control={control}
                    name='TipoBanioId'
                    render={({field}) => (
                      <Select
                        {...field}
                        key={field.value}
                        className='w-100'
                        options={bathroomType}
                        placeholder='Selecciona un Tipo de Baño'
                        value={bathroomType?.find((c: {value: string}) => c.value === field.value)}
                        onChange={(val) => field.onChange(val ? val.value : '')}
                      />
                    )}
                  />
                  <p
                    style={{
                      marginBottom: '0',
                      fontSize: '10px',
                      fontWeight: '600',
                      color: 'red',
                      marginLeft: '5px',
                    }}
                  >
                    {errors.TipoBanioId &&
                      typeof errors.TipoBanioId === 'string' &&
                      errors.TipoBanioId}
                  </p>
                </div>
              </div>
              <div className='mb-2 col-10'>
                <label className='required form-label'>Nivel</label>
                <div className='input-group input-group-sm'>
                  <Controller
                    control={control}
                    name='NivelId'
                    render={({field}) => (
                      <Select
                        {...field}
                        key={field.value}
                        className='w-100'
                        options={level}
                        placeholder='Selecciona un Nivel'
                        value={level?.find((c: {value: string}) => c.value === field.value)}
                        onChange={(val) => field.onChange(val ? val.value : '')}
                      />
                    )}
                  />
                  <p
                    style={{
                      marginBottom: '0',
                      fontSize: '10px',
                      fontWeight: '600',
                      color: 'red',
                      marginLeft: '5px',
                    }}
                  >
                    {errors.NivelId && typeof errors.NivelId === 'string' && errors.NivelId}
                  </p>
                </div>
              </div>
            </div>
            <div className='col-xs-12 col-sm-6 col-lg-3'>
              <div className='mb-2 col-10'>
                <label className='required form-label'>Nro de Habitaciones</label>
                <div className='input-group input-group-sm'>
                  <div className='sdx_form_input w-100 p-0'>
                    <input
                      type='text'
                      className='form-control sdx-centra-input-form'
                      {...register('NroHabitaciones')} // Aplicar las reglas de validación al registro
                    />
                  </div>
                  <p
                    style={{
                      marginBottom: '0',
                      fontSize: '10px',
                      fontWeight: '600',
                      color: 'red',
                      marginLeft: '5px',
                    }}
                  >
                    {errors.NroHabitaciones &&
                      typeof errors.NroHabitaciones === 'string' &&
                      errors.NroHabitaciones}
                  </p>
                </div>
              </div>
              <div className='mb-2 col-10'>
                <label className='required form-label'>Prioridad de Asignación</label>
                <div className='input-group input-group-sm'>
                  <div className='sdx_form_input w-100 p-0'>
                    <input
                      type='text'
                      className='form-control sdx-centra-input-form'
                      {...register('PrioridadAsignacion')} // Aplicar las reglas de validación al registro
                    />
                  </div>
                  <p
                    style={{
                      marginBottom: '0',
                      fontSize: '10px',
                      fontWeight: '600',
                      color: 'red',
                      marginLeft: '5px',
                    }}
                  >
                    {errors.PrioridadAsignacion &&
                      typeof errors.PrioridadAsignacion === 'string' &&
                      errors.PrioridadAsignacion}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
      </KTCard>
    </>
  )
}

export {FormNewModule}
